import React, { useEffect, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import { createModal } from "../hooks/createModal";
import GlobalClassFile from "../popups/GlobalClassFile";
import Debug from "./Debug";
import EmployeeLogin from "../popups/EmployeeLogin";
import Setup from "../popups/Setup";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import InventoryController from "./InventoryController";
import { createScreen } from "../hooks/createScreen";
import DocumentationController from "./DocumentationController";
import { createEmpty } from "../hooks/createEmpty";
import InventorySearch, { callSearch } from "../popups/InventorySearch";
import { getSignal } from "../App";
import InventoryOrder from "../components/InventoryOrder";
import ReconciliationController from "./ReconciliationController";
import { kbdEvent } from "../utils/Utils";
import BugReport from "../popups/BugReport";


let inventory_loaded = false;
let order_loaded = false;
// Only load one instance of this...
export const loadInventory = (_keyboard_event) => {
    if (inventory_loaded) {
        showMessage("Inventory Already Loaded")
        return;
    } else {
        inventory_loaded = true;
    }
    const origin = window.bm_state.value;
    const origin_controller = window.ac;
    window.ac = "global";
    const signal = getSignal();
    createScreen({
        globalScreen: true,
        signal: signal,
        component: <InventoryController controller={"global"} flag="global" is_global={true} setController={() => { }} signal={signal} route={ROUTES.INVENTORY.INVENTORY} />, closable: false, title: "Select Customer",
        callback: (_obj) => {
            window.ac = origin_controller;
            window.bm_state.value = origin;
            inventory_loaded = false;
            _keyboard_event?.target?.focus?.();
        }
    });
}


let bugReportLoaded = false;

export const drawBugReport = (returnFocus = document.activeElement) => {
    
    if (bugReportLoaded) return;

    const returnLocation = {
        controller: window.ac,
        route: window.bm_state.value,
    };

    bugReportLoaded = true;
    window.ac = "global";
    window.bm_state.value = ROUTES.GLOBAL.BUG_REPORT;

    createModal({
        title: "Report a bug",
        closable: false,
        mask_close: false,
        component: (
            <BugReport returnLocation={returnLocation} />
        ),
        callback: (submitted) => {
            window.ac = returnLocation.controller;
            window.bm_state.value = returnLocation.route;
            bugReportLoaded = false;

            if (returnFocus?.isConnected) {
                returnFocus.focus();
            }

            if (submitted) {
                showMessage("Bug report submitted. Thank you.");
            }
        },
    });
};


export const drawOrder = () => {




    if (order_loaded) {
        showError({ error: "Inventory Already Loaded" })
        return;
    } else {
        order_loaded = true;
    }


    const origin = window.bm_state.value;
    const origin_controller = window.ac;
    window.ac = "global";
    const signal = getSignal();
    window.bm_state.value = ROUTES.INVENTORY.ORDER
    createModal({
        component: <InventoryOrder route={ROUTES.INVENTORY.ORDER} controller={"global"} />, closable: true, title: "Order",
        callback: (e) => {
            order_loaded = false;
        }
    });

}


function GlobalKeywordResults({ term, signal, callback }) {
    const [search, setSearch] = useState(null);

    useEffect(() => {
        let active = true;

        callSearch(
            "stock.searchKeyword",
            { limit: 100, offset: 0, keyword: term },
            "keyword",
            term,
            (success, data, type, message, searchTerm) => {
                if (!active) return;

                if (!success) {
                    showError(data);
                    callback(null);
                    return;
                }

                setSearch({
                    results: {
                        type,
                        data,
                        message,
                        term: searchTerm,
                        new_tab: false,
                    },
                    message: "",
                });
            }
        );

        return () => {
            active = false;
        };
    }, [term]);

    if (!search) {
        return (
            <div
                role="status"
                aria-live="polite"
                style={{ padding: "30px", textAlign: "center" }}
            >
                Searching…
            </div>
        );
    }

    return (
        <InventoryController
            controller="global"
            is_global={true}
            setController={() => { }}
            signal={signal}
            route={ROUTES.INVENTORY.INVENTORY}
            search={search}
            callback={callback}
        />
    );
}

export const drawKeywordSearch = (value) => {
    const term = value.trim();
    if (!term) return;

    if (inventory_loaded) {
        showMessage("Inventory Already Loaded");
        return;
    }

    inventory_loaded = true;

    const origin = window.bm_state.value;
    const originController = window.ac;
    const signal = getSignal();

    window.ac = "global";
    window.bm_state.value = ROUTES.INVENTORY.INVENTORY;

    const close = createScreen({
        globalScreen: true,
        signal,
        component: <GlobalKeywordResults term={term} signal={signal} />,
        closable: false,
        title: "Search Results",
        callback: () => {
            window.ac = originController;
            window.bm_state.value = origin;
            inventory_loaded = false;
        },
    });

    if (!close) {
        window.ac = originController;
        window.bm_state.value = origin;
        inventory_loaded = false;
    }
};


export const drawProductSearch = ({ keyboard_event = {}, controller = "global", return_search = false, callback = () => { } }) => {

    if (window.bm_state.value === ROUTES.INVENTORY.INVENTORY) {
        setTimeout(() => {
            kbdEvent(KBD.S);
        }, 50)
        return;
    }


    if (inventory_loaded) {
        showError({ error: "Inventory Already Loaded" })
        return;
    } else {
        inventory_loaded = true;
    }


    const origin = window.bm_state.value;
    const origin_controller = window.ac;
    window.ac = controller;
    const signal = getSignal();
    window.bm_state.value = ROUTES.INVENTORY.SEARCH
    createModal({
        component: <InventorySearch controller={controller} setStock={() => { }} selected={{}} route={ROUTES.INVENTORY.SEARCH} />, closable: true, title: "Product Search",
        callback: (e, _searchMsg) => {
            // Manual close

            if (!e) {
                window.bm_state.value = origin;
                window.ac = origin_controller;
                inventory_loaded = false;

                keyboard_event?.target?.focus?.();
                callback(false)
                return;
            } else {
                window.bm_state.value = ROUTES.INVENTORY.INVENTORY
                createScreen({
                    globalScreen: true,
                    signal: signal,
                    component: <InventoryController return_search={return_search} controller={"global"} search={{ results: e, message: _searchMsg }} is_global={true} setController={() => { }} signal={signal} route={ROUTES.INVENTORY.INVENTORY} />, closable: false, title: "Select Customer",
                    callback: (_obj) => {


                        window.bm_state.value = origin;
                        window.ac = origin_controller;
                        inventory_loaded = false;
                        keyboard_event?.target?.focus?.();
                        if (return_search) {
                            callback(_obj);
                        }
                    }
                });
            }
            return;
        }
    });
}


export default function GlobalController(props) {

    const { signal = {}, WS_ONLY = false, controller = "", setController = () => { } } = props;


    const drawInventory = () => {
        if (window.bm_state.value === ROUTES.INVENTORY.INVENTORY) {
            return;
        }
        const origin = window.bm_state.value;
        createScreen({
            globalScreen: true,
            signal: signal,
            component: <InventoryController controller={controller} flag="global" is_global={true} setController={() => { }} signal={signal} route={ROUTES.INVENTORY.INVENTORY} />, closable: false, title: "Select Customer",
            callback: (_obj) => {
                window.bm_state.value = origin;
            }
        });

    }


    const drawReconciliation = () => {
        if (window.bm_state.value === ROUTES.RECONCILIATION.RECONCILIATION) {
            return;
        }
        const origin = window.bm_state.value;
        window.bm_state.value = ROUTES.RECONCILIATION.RECONCILIATION;
        createScreen({
            globalScreen: true,
            signal: signal,
            component: <ReconciliationController controller={controller} flag="global" is_global={true} setController={() => { }} signal={signal} route={ROUTES.RECONCILIATION.RECONCILIATION} />, closable: false, title: "Select Customer",
            callback: (_obj) => {

                window.bm_state.value = origin;
            }
        });

    }




    const drawClassFile = () => {
        const origin = window.bm_state.value;
        window.bm_state.value = ROUTES.GLOBAL.CLASSFILE;
        createModal({
            component: <GlobalClassFile controller={controller} signal={signal} route={ROUTES.GLOBAL.CLASSFILE} />, closable: true, title: "Classification File", callback: () => {
                window.bm_state.value = origin;
            }
        })
    }

    const drawDebug = () => {

        const origin = window.bm_state.value;
        window.bm_state.value = ROUTES.GLOBAL.CLASSFILE;
        createModal({
            component: <Debug controller={controller} route={ROUTES.GLOBAL.CLASSFILE} />, closable: true, title: "Debug", callback: () => {
                window.bm_state.value = origin;
            }
        })
    }

    const drawLogin = () => {

        // Logout if already logged in
        if (signal?.value?.session?.clerk_code) {
            pubCall("employee.logout", {}, (_s, _r) => {
                if (_s) {
                    signal.value = { ...signal.value, "session": _r }
                    showMessage("Active user has been logged out.")
                } else {
                    showError(_r);
                }
            })
            return;
        }

        const origin = window.bm_state.value;
        window.bm_state.value = ROUTES.GLOBAL.EMPLOYEE_LOGIN;
        createModal({
            component: <EmployeeLogin controller={controller} signal={signal} route={ROUTES.GLOBAL.EMPLOYEE_LOGIN} />, closable: true, title: "Login", callback: () => {
                window.bm_state.value = origin;
            }
        })
    }

    const drawSetup = () => {
        const origin = window.bm_state.value;
        window.bm_state.value = ROUTES.GLOBAL.SETUP;
        createModal({
            component: <Setup controller={controller} signal={signal} route={ROUTES.GLOBAL.SETUP} />, closable: true, title: "Setup Options", callback: () => {
                window.bm_state.value = origin;
            }
        })
    }


    const drawDocs = () => {

        const origin = window.bm_state.value;
        window.bm_state.value = ROUTES.GLOBAL.SETUP;
        createEmpty({
            component: <DocumentationController controller={controller} signal={signal} route={ROUTES.GLOBAL.DOCS} />, closable: true, title: "Docs", callback: () => {
                window.bm_state.value = origin;
            }
        })
    }


    useEffect(() => {
        const onDrawReconciliation = (e) => drawReconciliation(e.detail);
        window.addEventListener("drawReconciliation", onDrawReconciliation);
        return () => {
            window.removeEventListener("drawReconciliation", onDrawReconciliation);
        }
    }, []);



    useEffect(() => {

        const actions = [

            { key: KBD.F1, action: (e) => (window?.beta) ? "" : drawDebug() },
            // { key: KBD.F5, action: (e) => (window?.beta) ? "" : drawOrder() },
            {
                key: KBD.F2, action: (e) => {
                    if (!WS_ONLY) {
                        if (WS_ONLY || e.repeat) return;

                        const input = document.getElementById("header-product-search");

                        if (input) {
                            input.focus();
                            input.select();
                            return;
                        }
                        
                        drawProductSearch({ keyboard_event: e })

                    }
                }
            },
            { key: KBD.F4, action: (e) => { drawClassFile() } },
            { key: KBD.F5, action: (e) => { } },
            { key: KBD.CTRL_F5, action: (e) => { window.location.reload() } },
            { key: KBD.F6, action: (e) => { drawLogin() } },
            { key: KBD.F8, action: (e) => (window?.beta) ? "" : drawDocs() },
            { key: KBD.RECONCILIATION, action: (e) => { drawReconciliation() } },
            //  { key: KBD.F5, action: (e) => { drawLogin() } },
            { key: KBD.ALT_S, action: (e) => (window?.beta) ? "" : drawSetup() },


        ];
        const cleanup = listen("", ROUTES.GLOBAL.GLOBAL, actions, false);
        return cleanup;
    }, []);


    return (<></>)
}